/**
 * FN-FE-02 — FKeyBar — PROTOTÍPUS SZERINTI navy F-billentyű sáv
 */
import { useEffect, createContext, useContext, useState, type ReactNode } from 'react';

export interface FKeyItem { key: string; label: string; action: () => void }

interface FKeyBarContextType { setItems: (items: FKeyItem[]) => void }
const FKeyBarContext = createContext<FKeyBarContextType>({ setItems: () => {} });

export function useFKeyBar(items: FKeyItem[]) {
  const { setItems } = useContext(FKeyBarContext);
  useEffect(() => { setItems(items); return () => setItems([]); }, []);
}

export function FKeyBarProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<FKeyItem[]>([]);
  return (
    <FKeyBarContext.Provider value={{ setItems }}>
      {children}
      <FKeyBarInner items={items} />
    </FKeyBarContext.Provider>
  );
}

function FKeyBarInner({ items }: { items: FKeyItem[] }) {
  const displayItems = items.length > 0 ? items : [
    { key: 'F1', label: 'Súgó', action: () => {} },
    { key: 'F10', label: 'Menü', action: () => {} },
  ];

  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const item = displayItems.find(i => i.key.toLowerCase() === e.key.toLowerCase());
      if (item) { e.preventDefault(); item.action(); }
    }
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [displayItems]);

  return (
    <div className="fbar">
      {displayItems.map(item => (
        <button key={item.key} className="fk" onClick={item.action}>
          <b>{item.key}</b> {item.label}
        </button>
      ))}
      <span className="fk-hint">Tab: menüfülek · Enter: lenyitás · Esc: vissza</span>
    </div>
  );
}

export default function FKeyBar() {
  return null;
}
